import { GetBackAttivitaV2IdComunicazioniIdTipoDestinatario } from '@framework/api-client/api/backoffice/schemas/getBackAttivitaV2IdComunicazioniIdTipoDestinatario.ts';
import { GetBackAttivitaV2IdComunicazioniIdTipoMittente } from '@framework/api-client/api/backoffice/schemas/getBackAttivitaV2IdComunicazioniIdTipoMittente.ts';
import { GetBackAttivitaV2IdComunicazioniStato } from '@framework/api-client/api/backoffice/schemas/getBackAttivitaV2IdComunicazioniStato.ts';
import { yup } from '@framework/validation/initYup.ts';
import { t } from 'i18next';
import { type ICommunicationListQuery } from '../CommunicationList.tsx';

export const CommunicationsSearchSchema: yup.ObjectSchema<ICommunicationListQuery> =
  yup.object({
    oggetto: yup.string().allowNullable().default(null),
    dataInvioDal: yup
      .string()
      .stringDate()
      .allowNullable()
      .default(null)
      .label(t('communication-search-schema.sent-after', 'Inviata dopo il')),
    dataInvioAl: yup
      .string()
      .stringDate()
      .allowNullable()
      .default(null)
      .label(t('communication-search-schema.sent-before', 'Inviata prima del')),
    pagina: yup.number().allowNullable().default(0),
    limite: yup.number().allowNullable().default(10),
    idIstanzaProcedimento: yup.string().allowNullable().default(null),
    idUtenteRichiesta: yup.string().allowNullable().default(null),
    idsUfficiUtenteRichiesta: yup
      .array(yup.string().required())
      .allowNullable()
      .default([]),
    idMittente: yup.string().allowNullable().default(null),
    idTipoMittente: yup
      .string()
      .oneOfEnum(GetBackAttivitaV2IdComunicazioniIdTipoMittente)
      .allowNullable()
      .default(null),
    idTipoDestinatario: yup
      .string()
      .oneOfEnum(GetBackAttivitaV2IdComunicazioniIdTipoDestinatario)
      .allowNullable()
      .default(null),
    messaggio: yup.string().allowNullable().default(null),
    mittente: yup.string().allowNullable().default(null),
    destinatario: yup.string().allowNullable().default(null),
    stato: yup
      .string()
      .oneOfEnum(GetBackAttivitaV2IdComunicazioniStato)
      .allowNullable()
      .default(null),
    idEndoprocedimento: yup.string().allowNullable().default(null),
    idTipoComunicazione: yup.string().allowNullable().default(null),
    flLetta: yup.boolean().allowNullable().default(null),
    ordinamenti: yup
      .array(
        yup
          .string()
          .allowNullable()
          .default('-dataModifica')
          .transform(v => (!v ? '-dataModifica' : v)),
      )
      .allowNullable()
      .default(['-dataModifica']),
  });
